<template lang='pug'>
  div
    h2 Programs
    h4 Project P.Raise
    p Where: Hawaii Youth Correctional Facility
    p When: Every SECOND and FOURTH Tuesday from 5:15 PM to 6:15 PM
    p In 2010, Hawaii CAN forged a new partnership with Hawaii Youth Correctional Facility (HYCF). Hawaii CAN trainers and dogs foster youth rehabilitation through a collaborative dog training program with HYCF students from Olomana School.
    p Currently, Hawaii leads the nation with 37 percent of incarcerated youth held behind bars because of status offenses (truancy, curfew violations, incorrigibility, running away, etc).
    | Once incarcerated, such children often feel that their future educational and career goals are limited. Hawaii CAN is working to help these youths develop not only possible career opportunities in the animal industry,
    | but also trust, empathy for others, and a hopeful outlook on their future. In working with Hawaii CAN, HYCF’s children will be studying the skills of pet care technicians,
    | which are skills marketable to many local pet care organizations and will provide a solid foundation for future careers in the pet care industry. Walking in for our bi-weekly class with these students, it’s inspiring to hear them say, “We’ve looked forward to this all week!”
</template>

<script>
export default {
  name: 'Home'
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Programs.vue